var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowGoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0147 0.43934L24.5607 9.98528C25.1464 10.5711 25.1464 11.5208 24.5607 12.1066L15.0147 21.6525C14.4289 22.2383 13.4792 22.2383 12.8934 21.6525C12.3076 21.0668 12.3076 20.117 12.8934 19.5312L19.8787 12.5459L1.5 12.5459C0.671573 12.5459 0 11.8744 0 11.0459C0 10.2175 0.671573 9.54594 1.5 9.54594L19.8787 9.54594L12.8934 2.56066C12.3076 1.97487 12.3076 1.02513 12.8934 0.43934C13.4792 -0.146447 14.4289 -0.146447 15.0147 0.43934Z",
    fill: "#FF931E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGoIcon);
export default __webpack_public_path__ + "static/media/arrow_go_icon.8712bbf15a87e631cc9b7691d34e0280.svg";
export { ForwardRef as ReactComponent };